import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, computed, input, model } from '@angular/core';

import { DS_ATOMS } from '@frontend/ui/shared';

export const DS_NOTIFICATION_BUBBLE_VARIANT_ARRAY = ['primary', 'utility', 'live', 'neutral', 'live-dot', 'utility-dot'] as const;
export type DsNotificationBubbleVariant = (typeof DS_NOTIFICATION_BUBBLE_VARIANT_ARRAY)[number];

export const DS_NOTIFICATION_BUBBLE_SIZE_ARRAY = ['small', 'medium', 'large'] as const;
export type DsNotificationBubbleSize = (typeof DS_NOTIFICATION_BUBBLE_SIZE_ARRAY)[number];

@Component({
    selector: 'ds-notification-bubble',
    template: `
        @if (variant() === 'live-dot' || variant() === 'utility-dot') {
            <div class="ds-notification-bubble-inside-dot"></div>
        } @else if (label()) {
            {{ label() }}
        } @else {
            <ng-content />
        }
    `,
    host: {
        'class': 'ds-notification-bubble',
        '[class]': 'hostClass()',
        '[class.ds-notification-bubble-disabled]': 'disabled()',
        '[class.ds-notification-bubble-inverse]': 'inverse()',
    },
    styleUrl: 'notification-bubble.component.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: DS_ATOMS,
            useFactory: () => 'ds-notification-bubble',
        },
    ],
})
export class DsNotificationBubble {
    public readonly label = model(''); // will be shown instead of projected content

    public readonly size = model<DsNotificationBubbleSize>('medium');
    public readonly variant = model<DsNotificationBubbleVariant>('primary');
    public readonly disabled = input(false, { transform: booleanAttribute });
    public readonly inverse = model<boolean>(false);

    public readonly hostClass = computed(() => `ds-notification-bubble-${this.size()} ds-notification-bubble-${this.variant()}`);
}
